<script setup lang="ts">
defineProps<{
  error: string
}>()
</script>

<template>
  <span aria-live="assertive" role="alert" :class="['text-xs font-medium text-red-500']">
    {{ error }}
  </span>
</template>
